import React, { useState } from "react"
import styled from "styled-components"
import Dollar from "./svg/dollar"
import Calendar from "./svg/calendar"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import LifetimeDeposit from "../content-tour-lifetime-deposit"

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Highlight = styled.div`
  border-radius: 6px;
  background: #f5faf8;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 16px;
  justify-content: flex-start;
  align-items: flex-start;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  @media (max-width: 1260px) {
    align-items: flex-start;
  }
`

const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  min-height: 34px;
  padding-right: 1px;
  border-radius: 21px;
  background: ${props => props.theme.secondary400};
`

const ExplanationLink = styled(Link)`
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
`
const Bold = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  text-decoration-style: solid;
`

const Description = styled.div`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  p {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
`

const ExplanationDesc = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
`

const RowText = styled(Row)`
  @media (max-width: 1260px) {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 4px;
  }
`

const TourDescription = ({ description, lifetime }) => {
  const [slotDeposit, setSlotDeposit] = useState(false)

  const handleLDClose = () => {
    setSlotDeposit(false)
  }

  return (
    <Column>
      <Highlight>
        {lifetime && (
          <Row>
            <Circle>
              <Dollar />
            </Circle>
            <RowText>
              <ExplanationLink
                as={"div"}
                onClick={() => {
                  setSlotDeposit(true)
                }}
              >
                Lifetime deposit
              </ExplanationLink>
              <ExplanationDesc>
                Never lose your deposit if you have to cancel your trip.
              </ExplanationDesc>
            </RowText>
          </Row>
        )}
        <Row>
          <Circle>
            <Calendar />
          </Circle>
          <RowText>
            <Bold>Personalized Service</Bold>
            <ExplanationDesc>
              Let our experienced travel advisors plan your perfect adventure
            </ExplanationDesc>
          </RowText>
        </Row>
      </Highlight>
      <Description dangerouslySetInnerHTML={{ __html: description }} />
      <LifetimeDeposit
        handleClose={handleLDClose}
        className={slotDeposit ? "" : "hidden"}
      />
    </Column>
  )
}

TourDescription.propTypes = {
  description: PropTypes.string,
  lifetime: PropTypes.bool,
}
export default TourDescription
